import { useState } from 'react';
import { useLang } from '../../context/LangContext';
import { useAuth } from '../../context/AuthContext';
import { COLORS } from '../../lib/constants';
import NotificationBell from '../../components/NotificationBell';
import Home from './Home';
import BusinessDetail from './BusinessDetail';
import BookingPage from './BookingPage';
import MyBookings from './MyBookings';
import ProfilePage from './ProfilePage';

const NAV = [
  { id: 'home', iconActive: '🏠', icon: '🏡', labelAr: 'الرئيسية', labelEn: 'Home' },
  { id: 'bookings', iconActive: '📅', icon: '📆', labelAr: 'حجوزاتي', labelEn: 'Bookings' },
  { id: 'profile', iconActive: '👤', icon: '👤', labelAr: 'حسابي', labelEn: 'Profile' },
];

export default function UserApp() {
  const { isRtl } = useLang();
  const { profile } = useAuth();
  const [screen, setScreen] = useState('home');
  const [selectedBusiness, setSelectedBusiness] = useState(null);
  const [bookingData, setBookingData] = useState(null);

  const goToBusiness = (biz) => { setSelectedBusiness(biz); setScreen('business'); };
  const goToBooking = (data) => { setBookingData(data); setScreen('booking'); };
  const goHome = () => { setScreen('home'); setSelectedBusiness(null); setBookingData(null); };

  return (
    <div style={{ maxWidth: '100%', margin: '0 auto', position: 'relative', minHeight: '100vh', background: COLORS.bg }}>
      {profile?.id && (
        <div style={{ position: 'fixed', top: 14, [isRtl ? 'left' : 'right']: 14, zIndex: 150 }}>
          <NotificationBell userId={profile.id} isRtl={isRtl} />
        </div>
      )}
      {screen === 'home' && <Home onSelectBusiness={goToBusiness} />}
      {screen === 'business' && <BusinessDetail business={selectedBusiness} onBook={goToBooking} onBack={goHome} />}
      {screen === 'booking' && <BookingPage data={bookingData} onBack={() => setScreen('business')} onSuccess={goHome} />}
      {screen === 'bookings' && <MyBookings />}
      {screen === 'profile' && <ProfilePage />}

      {!['business', 'booking'].includes(screen) && (
        <div style={{ position: 'fixed', bottom: 0, left: 0, right: 0, width: '100%', background: COLORS.white, borderTop: `1px solid ${COLORS.border}`, display: 'flex', padding: '8px 0 12px', zIndex: 100, boxShadow: '0 -4px 20px rgba(0,0,0,0.08)' }}>
          {NAV.map(item => (
            <button key={item.id} onClick={() => setScreen(item.id)} style={{ flex: 1, background: 'none', border: 'none', cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3, padding: '4px 0', fontFamily: 'Cairo, sans-serif' }}>
              <span style={{ fontSize: 22 }}>{screen === item.id ? item.iconActive : item.icon}</span>
              <span style={{ fontSize: 11, fontWeight: 600, color: screen === item.id ? COLORS.primary : COLORS.textMuted }}>
                {isRtl ? item.labelAr : item.labelEn}
              </span>
              {screen === item.id && <div style={{ width: 4, height: 4, borderRadius: '50%', background: COLORS.primary }} />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
